import React from "react";
import "../styles/Footer.css";


const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-content">

        <p>
          © {new Date().getFullYear()} Hooman. All rights reserved.
        </p>


        <div className="footer-links">

          <a
            href="https://github.com/hoomanyyy"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>


          <a href="#about">
            About
          </a>


          <a href="#projects">
            Projects
          </a>


          <a href="#skills">
            Skills
          </a>

        </div>

      </div>

    </footer>
  );
};


export default Footer;  